module.exports = __webpack_public_path__ + "img/university_13.b01c4834.png";